import { Axios, AxiosError, AxiosResponse } from 'axios'
import { RemoteConfig } from './remote.config'

export type ReportsForSourceCallback = (data?: number, resp?: AxiosResponse, err?: AxiosError) => void;

export const getFinishedScanCountForSource = (source: string, callback: ReportsForSourceCallback) => {
	const client = new Axios();
	const url = new URL(`/api/v0/scan/entity/${source}/finished`, RemoteConfig.url);
	const result = client.get(url.toString(), {withCredentials:true}).then((resp) => {
		try {
			let data: number = JSON.parse(resp.data)
			callback(data, resp)
		} catch {
			callback(undefined, resp)
		}
	})
}

export type LatestReportForSourceCallback = (data?: number, resp?: AxiosResponse, err?: AxiosError) => void;

export const getScanCountForSource = (source: string, callback: LatestReportForSourceCallback) => {
	const client = new Axios();
	const url = new URL(`/api/v0/scan/entity/${source}/total`, RemoteConfig.url);
	const result = client.get(url.toString(), {withCredentials:true}).then((resp) => {
		try {
			let data: number = JSON.parse(resp.data)
			callback(data, resp)
		} catch {
			callback(undefined, resp)
		}
	})
}
